module.exports = __webpack_public_path__ + "img/img3.8818ad59.jpg";